import React, { useState } from 'react';
import axios from 'axios';
import { Gift, Sparkles } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const NailCash = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', referrer: '' });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await axios.post(`${API_URL}/api/clients`, {
        name: form.name,
        email: form.email,
        phone: form.phone,
        subscription_tier: `Nail Cash Lead${form.referrer ? ` (Referred by ${form.referrer})` : ''}`,
      });
      setSubmitted(true);
    } catch {
      setError('Could not save right now. Please call 904.672.9966.');
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="py-32 text-center px-6" data-testid="nailcash-success">
        <Gift className="w-12 h-12 text-pink-300 mx-auto mb-6" />
        <h1 className="font-serif text-5xl text-amber-50">Your $10 is reserved!</h1>
        <p className="mt-4 text-amber-100/70 max-w-md mx-auto">
          We'll text you a unique code at <span className="text-amber-200">{form.phone}</span>. Use it on your first appointment.
        </p>
      </div>
    );
  }

  return (
    <div className="py-20" data-testid="nailcash-page">
      <div className="max-w-2xl mx-auto px-6">
        <div className="text-center mb-12">
          <Sparkles className="w-10 h-10 text-pink-300 mx-auto mb-4" />
          <div className="text-[10px] tracking-[0.35em] uppercase text-amber-300/70 mb-3">✦ Refer & Earn ✦</div>
          <h1 className="font-serif text-5xl sm:text-6xl text-amber-50" data-testid="nailcash-title">
            <span className="italic text-pink-300">$10 Nail Cash</span> on us
          </h1>
          <p className="mt-4 text-amber-100/70 max-w-lg mx-auto">
            New to the glow family? Drop your info below and we'll text you $10 Nail Cash to use on your first appointment. Already a client? Refer a friend and earn $10 every time.
          </p>
        </div>

        <form onSubmit={onSubmit} className="rounded-2xl border border-amber-900/30 bg-[#0a0405] p-8 md:p-10 space-y-5" data-testid="nailcash-form">
          <label className="block">
            <span className="text-xs tracking-wider uppercase text-amber-300/70">Full Name</span>
            <input
              name="name"
              required
              value={form.name}
              onChange={onChange}
              className="mt-2 w-full bg-black/40 border border-amber-900/30 rounded-md px-4 py-3 text-amber-50 focus:outline-none focus:border-pink-400/30"
              data-testid="nailcash-name"
            />
          </label>
          <label className="block">
            <span className="text-xs tracking-wider uppercase text-amber-300/70">Phone</span>
            <input
              name="phone"
              type="tel"
              required
              value={form.phone}
              onChange={onChange}
              className="mt-2 w-full bg-black/40 border border-amber-900/30 rounded-md px-4 py-3 text-amber-50 focus:outline-none focus:border-pink-400/30"
              data-testid="nailcash-phone"
            />
          </label>
          <label className="block">
            <span className="text-xs tracking-wider uppercase text-amber-300/70">Email</span>
            <input
              name="email"
              type="email"
              required
              value={form.email}
              onChange={onChange}
              className="mt-2 w-full bg-black/40 border border-amber-900/30 rounded-md px-4 py-3 text-amber-50 focus:outline-none focus:border-pink-400/30"
              data-testid="nailcash-email"
            />
          </label>
          <label className="block">
            <span className="text-xs tracking-wider uppercase text-amber-300/70">Referred by (optional)</span>
            <input
              name="referrer"
              value={form.referrer}
              onChange={onChange}
              placeholder="Friend's name"
              className="mt-2 w-full bg-black/40 border border-amber-900/30 rounded-md px-4 py-3 text-amber-50 focus:outline-none focus:border-pink-400/30"
              data-testid="nailcash-referrer"
            />
          </label>

          {error && <div className="text-pink-300 text-sm" data-testid="nailcash-error">{error}</div>}

          <button
            type="submit"
            disabled={submitting}
            className="w-full py-4 rounded-full bg-pink-300 text-black font-medium hover:bg-pink-200 transition-all disabled:opacity-60"
            data-testid="nailcash-submit"
          >
            {submitting ? 'Claiming...' : 'Claim My $10 Nail Cash'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default NailCash;
